import * as Config from '../../../../config';
import React from 'react';
import PropTypes from 'prop-types';

import GridFull from './GridFull';
import Card from '../../common/Card';
import CardLoading from '../../common/CardLoading';

import useArtists from '../../../../hooks/useArtists';

function GridArtists(props) {
  const { id, pathApi, width, rowCount, perPage, isBaseRootApi } = props;
  const perPageCal = perPage ?? Math.floor(width / Config.CARD_WIDTH) * rowCount;
  const [dataHook] = useArtists(id, pathApi, isBaseRootApi, perPageCal);

  return <GridFull
    {...props}
    gutter={{ top: 4, left: 4, width: 4, gap: 30 }}
    dataHook={dataHook}
    element={ <Card isOnlyCover={true} className={'card-artist'} /> }
    loadingElement={ <CardLoading isOnlyCover={true} /> }
  />
}

GridArtists.propTypes = {
  id: PropTypes.string.isRequired,
  width: PropTypes.any,
  height: PropTypes.number.isRequired,
  title: PropTypes.string,
  pathApi: PropTypes.string.isRequired,
  isBaseRootApi: PropTypes.bool.isRequired,
  hasFilters: PropTypes.bool,
  filtersStyle: PropTypes.object,
  forceHeight: PropTypes.number,
  rowCount: PropTypes.number,
  rowHeight: PropTypes.number,
  columnCount: PropTypes.number,
  hasPagination: PropTypes.bool,
  perPage: PropTypes.number,
  allTo: PropTypes.any,
  style: PropTypes.object
}

export default GridArtists;
